import { LocalstorageService } from '@services/localstorage.service';
import {inject} from "@angular/core";
import {UserProfileService} from "@services/user-profile.service";
import {GoogleTagManagerService} from "@services/GTM/google-tag-manager.service";
import { Observable, tap } from "rxjs";
import { AuthService } from "../auth/auth.service";
import { PartnerService } from "@services/partner.service";
import { Dto } from '@models/dto.model';
import { UserInfo } from '@models/userInfo.dto';

/**
 * Send login event to Google Tag Manager only if the user is a customer or relationship profile
 */
export const SelectProfileCanDeactivateGuard = (): void => {
  const userProfileService: UserProfileService = inject(UserProfileService);

  if (userProfileService.isCustomerOrRelationshipProfile()) {
    const gtmService = inject(GoogleTagManagerService);
    const userId = userProfileService.getUserId();

    if (userId) {
      gtmService.postLoginGoogleTagManager(String(userId));
    }
  }
};

export const GetRolesCanDeactivateGuard: () => Observable<any> = () => {
  const userProfileService = inject(UserProfileService);

  // Não solicita as permissões do usuário com perfil cliente ou relacionamento, antes que ele selecione um contrato
  if (userProfileService.isCustomerOrRelationshipProfile()) {
    return new Observable((observer) => {
      observer.next(null);
      observer.complete();
    });
  }
  return inject(AuthService).setRolesOnStorage(userProfileService.isBackOffice());
}

export const GetPartnerUserInfoCanDeactivateGuard: () => Observable<any> = () => {
  const userProfileService = inject(UserProfileService);

  if (userProfileService.isPartner()) {
    const localstorageService = inject(LocalstorageService);

    return inject(PartnerService).getPartnerUserInfo()
      .pipe(
        tap((response: Dto<UserInfo>) => {
          if (response?.success && response.data) {
            localstorageService.setUser(response.data);
          }
        })
      );
  }
}

